export default "__VITE_ASSET__BEK6nxoC__"